var nameMatches = function (plan, required) { return plan.name.includes(required); };
/** Ids of the available plans that selecting `plan` pulls in, so they can be selected with it. */
export var getRequiredPlanIds = function (plans, plan) {
    return (plan.requires || []).flatMap(function (required) { return plans.filter(function (p) { return nameMatches(p, required); }).map(function (p) { return p.id; }); });
};
/** One message per unmet requirement among the selected plans. Empty when everything is satisfied. */
export var findUnmetRequirements = function (plans, selectedIds) {
    var selected = plans.filter(function (p) { return selectedIds.includes(p.id); });
    var messages = [];
    selected.forEach(function (plan) {
        (plan.requires || []).forEach(function (required) {
            if (!selected.some(function (p) { return nameMatches(p, required); })) {
                messages.push("".concat(plan.name, " requires the ").concat(required, " plan option."));
            }
        });
    });
    return messages;
};
